var _path, _path2, _path3, _ellipse, _path4, _ellipse2, _path5, _ellipse3, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _rect, _rect2, _rect3, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmailPanelBannerPhone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 89,
    viewBox: "0 0 375 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M340.649 51.5634C332.146 50.4808 327.422 62.3722 327.422 68.1462V77.8899H368.757C367.34 77.6193 369.23 75.2916 364.506 68.1462C359.782 61.0008 355.136 65.169 353.404 68.1462C351.83 63.2744 349.153 52.646 340.649 51.5634Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.132 61.4358C299.555 60.7592 294.789 68.1913 294.789 71.8001V77.8899H336.487C335.058 77.7208 336.964 76.266 332.198 71.8001C327.433 67.3343 322.747 69.9393 320.999 71.8001C319.411 68.7552 316.71 62.1125 308.132 61.4358Z",
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 76.8516H722",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.09,
    cy: 36.9602,
    rx: 15.867,
    ry: 18.0481,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M131.088 81.5337V43.5234",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 149.365,
    cy: 44.6164,
    rx: 15.867,
    ry: 18.0481,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M149.363 89.19V51.1797",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 288.543,
    cy: 54.0675,
    rx: 8.25744,
    ry: 15.7706,
    fill: "#C4D772",
    fillOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M288.543 83.0828V64.1035",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 72.9727L219.979 76.9443",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M245.58 68.3389V76.9441",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M215.32 68.3389V76.9441",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7754 68.3389V76.9441",
    stroke: "#68BFAC",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4688 35.2702L74.2536 2.30835L99.6061 35.2702",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5293 36.8391L62.5789 26.375V70.3241",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6074 1H138.014L156.643 28.7298",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M151.582 39.7168V67.7082",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.5684,
    y: 28.4688,
    width: 8.27956,
    height: 9.94086,
    fill: "#CADDFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5684,
    y: 41.0254,
    width: 16.0991,
    height: 9.94086,
    fill: "#CADDFD"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65.5684,
    y: 55.1514,
    width: 8.27956,
    height: 15.1729,
    fill: "#F3C477"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M95.6973 38.9326V69.8016",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5078 14.6035V1.52344H65.3376V9.10988",
    stroke: "#F3C477",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPanelBannerPhone);
export default __webpack_public_path__ + "static/media/email-panel-banner-phone.abd0d4a7.svg";
export { ForwardRef as ReactComponent };